import { CloseSmall } from '@components/icons'
import { useUI } from '@components/ui'
import Cookies from 'js-cookie'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

type Props = {
  lineItems: any[]
  rule: any
}

function CartSidebarMessage({ lineItems, rule }: Props) {
  const { t } = useTranslation('common')
  const [showMessage, setShowMessage] = useState(false)
  const { closeSidebarIfPresent } = useUI()
  const { push } = useRouter()
  const cookieName = `cart_message_closed_${rule?.id || 'default'}`

  useEffect(() => {
    const isClosed = Cookies.get(cookieName)
    if (isClosed) {
      setShowMessage(false)
      return
    }

    if (lineItems.length > 0 && rule) {
      let passedRule = true
      let ruleValueSet: any = {}
      rule?.condition.forEach((element: any) => {
        ruleValueSet[element.attribute] = []
      })
      lineItems.forEach((item) => {
        for (const key in ruleValueSet) {
          if (Array.isArray(item[key])) ruleValueSet[key].push(...item[key])
          else ruleValueSet[key].push(item[key])
        }
      })

      rule?.condition.forEach((element: any) => {
        let passed = false
        element.values.forEach((value: any) => {
          passed ||= ruleValueSet[element.attribute].includes(value)
        })
        passedRule &&= element.has === passed
      })
      setShowMessage(passedRule)
    }
  }, [lineItems, rule, cookieName])

  const goToLink = () => {
    push(rule?.link?.url || '/')
    closeSidebarIfPresent()
  }

  const handleClose = () => {
    const sevenDaysFromNow = new Date()
    sevenDaysFromNow.setDate(sevenDaysFromNow.getDate() + 7)
    Cookies.set(cookieName, 'true', {
      expires: sevenDaysFromNow,
    })
    setShowMessage(false)
  }

  return showMessage ? (
    <div className="relative mx-5 mb-4 flex justify-start gap-x-2 bg-ui-lightest-grey p-3">
      <div className="flex flex-col items-start gap-y-[6px] text-dark-grey">
        <div className="body-2"> {t(rule?.messageKey)}</div>
        <div className="body-3-bold border-b border-ui-dark-grey">
          {rule?.link && (
            <button className="!capitalize" onClick={goToLink}>
              {t(rule?.link.textKey).toUpperCase()}
            </button>
          )}
        </div>
      </div>
      <button
        onClick={handleClose}
        aria-label={t('close', { defaultValue: 'Close' })}
        className="flex h-4"
      >
        <CloseSmall />
      </button>
    </div>
  ) : null
}

export default CartSidebarMessage
